import axios from 'axios';

const instance = axios.create({
  headers: {
    'x-requested-with': 'XMLHttpRequest',
  },
});

export default instance;
